import { Component, OnInit } from '@angular/core';
import { first, map, take } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-privacy',
  templateUrl: './show-privacy.component.html',
  styleUrls: ['./show-privacy.component.scss'],
})
export class ShowPrivacyComponent implements OnInit {
  privacy = '';

  constructor(private db: DbService) {}

  async ngOnInit(): Promise<void> {
    const admin = await this.db.doc$('master/masterInfo').pipe(take(1)).toPromise();
    this.privacy = admin.termsInfo.privacy;
  }
}
